import { render, staticRenderFns } from "./InMapLegendList.vue?vue&type=template&id=621f3eba&"
import script from "./InMapLegendList.vue?vue&type=script&lang=js&"
export * from "./InMapLegendList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports